import React from "react";
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  TabContent,
  TabPane,
} from "reactstrap";
import AuthFooter from "components/Footers/AuthFooter.js";
import logo from "../../assets/img/logo1.jpg";
import OverseasTrainingTable2026 from "components/Tables/OverseasTrainingTable2026.js";
import OverseasTrainingTable2025 from "components/Tables/OverseasTrainingTable2025.js";

export default function OverseasTrainingCalendar() {
  const [navbarColor] = React.useState("info");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState(String(new Date().getFullYear()));

  const handleAppClick = () => {
    if (collapseOpen === true) {
      document.documentElement.classList.toggle("nav-open");
      setCollapseOpen(false);
    }
  };

  return (
    <div>
      <div id="app">
        <h1 className="sr-only">Home section</h1>
        <Navbar
          className={"fixed-top " + navbarColor}
          expand="lg"
          style={{ marginTop: 0 }}
        >
          <Container>
            <div className="navbar-translate">
              <NavbarBrand href="/" data-placement="bottom">
                <div className="d-flex">
                  <img
                    alt="Course App"
                    src={logo}
                    style={{
                      height: "40px",
                      width: "auto",
                      borderRadius: "4px",
                      marginRight: "5px",
                    }}
                  />
                  <h3
                    style={{
                      fontWeight: 600,
                      textDecoration: "none",
                      textTransform: "capitalize",
                      fontSize: "22px",
                    }}
                  >
                    GSR TRAINING CONSULTING
                  </h3>
                </div>
              </NavbarBrand>
            </div>
            <div
              className="phone-view-hide"
              style={{ marginRight: "20px" }}
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(true);
              }}
              aria-expanded={collapseOpen}
            >
              <i className="fa fa-bars" style={{ color: "white" }} />
            </div>
            <Collapse
              className="justify-content-end"
              isOpen={collapseOpen}
              navbar
            >
              <Nav navbar>
                <NavItem className="active">
                  <NavLink tag="a" href="/" className="mr-3">
                    HOME
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="mt--2 mr-2"
                    href="/overseas-training-calendar"
                    style={{
                      fontWeight: "700",
                      color: "yellow",
                      backgroundColor: "#17d0cf",
                      padding: "10px",
                      borderRadius: "10px",
                    }}
                  >
                    OVERSEAS CALENDAR
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="mt--2"
                    href="/zambia-training-calendar"
                    style={{
                      fontWeight: "700",
                      color: "#1a1a1a",
                      backgroundColor: "#c9a227",
                      padding: "10px",
                      borderRadius: "10px",
                    }}
                  >
                    ZAMBIA CALENDAR
                  </NavLink>
                </NavItem>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>

        <div>
          <div onClick={() => handleAppClick()}>
            <div style={{ marginTop: "150px", marginBottom: "100px" }}>
              <Container>
                <h4 className="head-subtitle">calendar</h4>
                <h2 className="big-text" style={{ marginLeft: "0px", marginBottom: "30px" }}>
                  Overseas Training <strong>Calendar</strong>
                </h2>

                {/* Year tabs */}
                <Nav tabs style={{ marginBottom: "30px" }}>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={activeTab === "2025" ? "active" : ""}
                      onClick={() => setActiveTab("2025")}
                    >
                      <span style={{ fontWeight: "600", color: activeTab === "2025" ? "#17d0cf" : "#333" }}>
                        2025
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={activeTab === "2026" ? "active" : ""}
                      onClick={() => setActiveTab("2026")}
                    >
                      <span style={{ fontWeight: "600", color: activeTab === "2026" ? "#17d0cf" : "#333" }}>
                        2026
                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>

                <div className="row wow fadeInUp" data-wow-duration="2s">
                  <div className="col-sm-12">
                    <div
                      className="bottom-section text-center"
                      style={{ overflow: "auto" }}
                    >
                      <TabContent activeTab={activeTab}>
                        <TabPane tabId="2025">
                          <OverseasTrainingTable2025 />
                        </TabPane>
                        <TabPane tabId="2026">
                          <OverseasTrainingTable2026 />
                        </TabPane>
                      </TabContent>
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </div>
          <AuthFooter />
        </div>
      </div>
    </div>
  );
}
